import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tagBlock']

  showMore(event) {
    const parent = event.target.closest("[data-tags-target='container']")
    const blocks = parent.querySelectorAll('.tag-block.hidden')

    blocks.forEach(block => block.classList.remove('hidden'))

    event.target.remove()
  }
}
